import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import addWorkorderParent from './parent.vue';

var AddWorkOrderPage = function (_super) {
  __extends(AddWorkOrderPage, _super);

  function AddWorkOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddWorkOrderPage = __decorate([Component({
    components: {
      addWorkorderParent: addWorkorderParent
    }
  })], AddWorkOrderPage);
  return AddWorkOrderPage;
}(Vue);

export default AddWorkOrderPage;